import { hashKey, useQuery } from '@tanstack/react-query';

import { CompanyCriteria } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface ForwardersMeta {
  total: number;
}

export const useForwardersMeta = (filters: CompanyCriteria['filters']) =>
  useQuery({
    queryKey: ['forwarders-meta', hashKey([filters])],
    queryFn: async (): Promise<ForwardersMeta> => {
      try {
        const result = await apiClient.forwarder.retrieveForwardersMetadata.mutation({ body: { filters } });
        if (result.status === 200) {
          return { total: result.body.metadata.total };
        } else {
          throw new Error(`Unexpected response status: ${result.status}`);
        }
      } catch (error) {
        showErrorToast(error, 'Failed to fetch forwarders metadata');
      }
    },
    placeholderData: {
      total: 0,
    },
  });
